import {nanoid} from "nanoid"
import seedrandom from "seedrandom"
import isString from "./isString"

export default class Random {
    constructor() {
        this.seed = nanoid()
        this.random = new seedrandom(this.seed)
    }
    sign() {
        return this.random() < 0.5 ? -1 : +1
    }
    range(a, b) {
        const min = Math.min(a, b)
        const max = Math.max(a, b)
        return min + (this.random() * (max - min))
    }
    element(array) {
        return array[Math.floor(this.random() * array.length)]
    }
    elementFromSeededKey(array, key) {
        const seedValue = convertURLFriendlyBase64ToInt(this.seed.slice(0, 5))
        const keyValue = convertURLFriendlyBase64ToInt(key.slice(0, 5))
        const seededKeyedRandom = seedValue + keyValue
        return array[seededKeyedRandom % array.length]
    }
    shuffle(array) {
        const superarray = array.slice()
        for(let i = superarray.length - 1; i > 0; i -= 1) {
            let j = Math.floor(this.random() * (i + 1))
            let temp = superarray[i]
            superarray[i] = superarray[j]
            superarray[j] = temp
        }
        return superarray
    }
    setSeed(seed) {
        this.seed = seed
        this.random = new seedrandom(seed)
    }
    identifier(length = 5) {
        const num = Math.floor(this.random() * Math.pow(10, length))
        return num + ""
    }
    id() {
        this.identifier()
    }
    key() {
        this.identifier()
    }
}

function convertURLFriendlyBase64ToInt(input) {
    let result = 0
    if(isString(input) == true) {
        input.split("").forEach(character => {
            result *= 64
            let decimalValue = undefined
            if (character >= "a" && character <= "z") decimalValue = character.charCodeAt(0) - "a".charCodeAt(0)
            if (character >= "A" && character <= "Z") decimalValue = character.charCodeAt(0) - "A".charCodeAt(0) + 26
            if (character >= "0" && character <= "9") decimalValue = character.charCodeAt(0) - "0".charCodeAt(0) + 52
            if (character == "-") decimalValue = 62
            if (character == "_") decimalValue = 63
            result += decimalValue
        })
        return result
    } else {
        console.warn("unit has key that is not random string. This should be deprecated")
        if(typeof input === "number") {
            return input
        }
    }
}
